import { CARREGAR_DISTRITOS_SUCESSO } from '../actions/actionTypes';
import initialState from './initialState.reducer';

export default (state = initialState.distritos, action) => {
  if (action.type === CARREGAR_DISTRITOS_SUCESSO)
    return action.distritos;

  return state;
};